import runs from "@/services/runs";

/**
 * Registra uma execução (sucesso ou falha) para o dashboard do perfil.
 * `run` é o resumo devolvido pela API do módulo: modo (local ou Slurm), nós, processos,
 * plano simples/complexa e tempos do job. Falhas aqui nunca afetam a simulação.
 */
export function recordRun({ state, kind, startedAt, status, error, run, production, params }) {
  const finishedAt = Date.now();
  runs
    .post("/", {
      author: state.author,
      kind,
      simulation: state.id,
      title: state.title,
      production,
      status,
      error: error ? String(error).slice(0, 500) : undefined,
      startedAt,
      finishedAt,
      durationS: (finishedAt - startedAt) / 1000,
      params,
      run
    })
    .catch(() => {});
}

// Tamanho do problema 2D (as mesmas grandezas que o cluster usa para decidir os recursos)
export function params2d(state) {
  const coordinates = state.coordinates || {};
  return {
    resolution: Number(state.resolution) || undefined,
    cellX: Number(coordinates.x) || undefined,
    cellY: Number(coordinates.y) || undefined,
    until: Number(state.until) || undefined,
    geometries: (state.GeometryList || []).length,
    sources: (state.SourcesList || []).length,
    monitors: (state.FluxList || []).length,
    video: !!(state.plotOptions && state.plotOptions.generateVideo === 1)
  };
}

export function params3d(state, quality, mesh) {
  return {
    quality,
    geometries: (state.GeometryList || []).length,
    sources: (state.SourcesList || []).length,
    elements: mesh && Number(mesh.elements) ? Number(mesh.elements) : undefined
  };
}
